<template>
  <div>
    <v-layout row class="">
      <v-flex xs12 offset-sm3 class="">
        <v-card class="no-shadow">
          <v-toolbar flat class=" white text-xs-center" dark xs12>
            <router-link v-show="!show" to="/ClassFilter" class="no-deraction pl-3">
              <v-icon class="grey--text pt-2">fas fa-arrow-left</v-icon>
            </router-link>
            <v-spacer></v-spacer>
            <v-toolbar-title>
              <div v-show="!show" class="pl-5 grey--text text-xs-center font-weight-bold f-20">Chat Lists</div>
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items class="hidden-sm-and-down"></v-toolbar-items>
            <v-btn flat icon v-show="!show" v-on:click='show = !show' icon large class=" no-shadow">
              <v-icon class="grey--text">search</v-icon>
            </v-btn>
            <v-container v-show="show" class="pt-0">
              <v-layout wrap row >
                <v-flex xs10 lg11 class="text-xs-left">
                  <div v-show="show">
                    <v-flex xs12 class="white text-xs-left">
                      <v-text-field class="pa-0 "
                          background-color="grey lighten-4"
                          prepend-inner-icon="search"
                          label="Search campaigns"
                          value="adam"
                          single-line
                          solo
                      ></v-text-field>
                    </v-flex>
                  </div>
                </v-flex>
                <v-flex xs2 lg1 class="right">
                  <div v-show="show" class="left">
                    <v-btn large icon flat class="left" v-show="show" v-on:click='show = !show'>
                      <v-icon class="grey--text font-weight-bold f-35">close</v-icon>
                    </v-btn>
                  </div>
                </v-flex>
                sdvredsfv
              </v-layout>
            </v-container>

          </v-toolbar>

          <v-list subheader class="">
            <v-subheader>Recent chats</v-subheader>
            <v-list-tile
              v-for="item in chatList"
              :key="item.id"
              avatar
              @click="RedirectChat(item)"
            >
              <v-list-tile-avatar>
                <img class="objec-fit" v-if="item.type=='receive'" :src="item.sender.image">
                <img class="objec-fit" v-if="item.type=='send'" :src="item.receiver.image">
              </v-list-tile-avatar>

              <v-list-tile-content>
                <v-list-tile-title v-if="item.type=='receive'" v-html="item.sender.name"></v-list-tile-title>
                <v-list-tile-title v-if="item.type=='send'" v-html="item.receiver.name"></v-list-tile-title>
                <v-list-tile-sub-title v-html="item.sub"></v-list-tile-sub-title>
              </v-list-tile-content>

              <v-list-tile-action>
                <v-icon  :color="item.active ? 'green' : 'grey'">fas fa-circle</v-icon>
              </v-list-tile-action>
            </v-list-tile>
          </v-list>

          <v-divider></v-divider>

          <v-list subheader class="" v-if="contactsList.length!=0">
            <v-subheader>Previous chats</v-subheader>

            <v-list-tile
              :to="'/Chats/'+item.id+'/contact'"
              v-for="item in contactsList"
              :key="item.id"
              avatar
              @click=""
            >

              <v-list-tile-avatar>
                <img class="objec-fit" :src="item.image">
              </v-list-tile-avatar>

              <v-list-tile-content>
                <v-list-tile-title v-html="item.name"></v-list-tile-title>
                <v-list-tile-sub-title v-html="item.sub"></v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
        </v-card>
      </v-flex>
    </v-layout>
  </div>

</template>
<script>
  /* eslint-disable */
  import api from "@/utils/backend-api"
  import {mapState} from 'vuex'

  export default {
    data () {
      return {
        show:false,
        items: [
          { active: true, title: 'Adam', avatar: 'https://cdn.vuetifyjs.com/images/lists/1.jpg' },
          { active: true, title: 'Adam', avatar: 'https://cdn.vuetifyjs.com/images/lists/1.jpg' },
          { active: true, title: 'Adam', avatar: 'https://cdn.vuetifyjs.com/images/lists/1.jpg' },
          { active: true, title: 'Adam', avatar: 'https://cdn.vuetifyjs.com/images/lists/1.jpg' },
          { active: true, title: 'Adam', avatar: 'https://cdn.vuetifyjs.com/images/lists/1.jpg' },
          { active: true, title: 'Adam', avatar: 'https://cdn.vuetifyjs.com/images/lists/1.jpg' },
          { active: true, title: 'Adam', avatar: 'https://cdn.vuetifyjs.com/images/lists/1.jpg' },
          { active: true, title: 'Adam', avatar: 'https://cdn.vuetifyjs.com/images/lists/1.jpg' },
          { active: true, title: 'Mac', avatar: 'https://cdn.vuetifyjs.com/images/lists/2.jpg' },
          { active: true, title: 'Halina', avatar: 'https://cdn.vuetifyjs.com/images/lists/2.jpg' },
          { active: true, title: 'Petter', avatar: 'https://cdn.vuetifyjs.com/images/lists/2.jpg' }
        ],
        items2: [
          { title: 'Driver School', avatar: 'https://cdn.vuetifyjs.com/images/lists/5.jpg' }
        ],
        chatList:[],
        tempChatList:[],
        contactsList:[],
        tempContactList:[]
      }
    },
    created:function(){
      this.adminUserImage=Store.state.user.image
      api.postData('admin/getAllMessage')
      .then(res=>{
        this.chatList=res.data.chat
        this.tempChatList=res.data.chat
        this.contactsList=res.data.contact
        this.tempContactList=res.data.contact
      }).catch(err=>{
        // debugger

      })
    },
    methods:{
      RedirectChat(item){
        console.log(item)
        if(item.type=='send'){
          let userid=item.receiver_id;

        }
      }
    },
    computed: {
      ...mapState([
        'chatMessages'
      ]),

      icon() {
        return this.icons[this.iconIndex]
      }
    },
  }
</script>
<style>
  input {
    outline: none;
  }
  input[type=search] {
    -webkit-appearance: textfield;
    -webkit-box-sizing: content-box;
    font-family: inherit;
    font-size: 100%;
  }
  input::-webkit-search-decoration,

  input[type=search] {
    background: url(https://static.tumblr.com/ftv85bp/MIXmud4tx/search-icon.png) no-repeat 9px center;
    /*border: solid 1px #ccc;*/
    padding: 7px 9px 7px 17px;
    width: 100%;
    border-radius: 50px;
    -webkit-transition: all .5s;
    -moz-transition: all .5s;
    transition: all .5s;
  }
  input[type=search]:focus {
    width: 100%;
    background-color: #fff;
    -webkit-box-shadow: 0 0 5px rgba(0, 81, 160, 0.5);
    -moz-box-shadow: 0 0 5px rgba(0, 81, 160, 0.5);
    box-shadow: 0 0 5px rgba(0, 81, 160, 0.5);
  }

  #demo-2 input[type=search] {
    width: 15px;
    padding-left: 10px;
    color: transparent;
    cursor: pointer;
  }
  #demo-2 input[type=search]:hover {
    background-color: #fff;
  }
  #demo-2 input[type=search]:focus {
    width: 250px;
    border: solid 1px #ccc;
    padding-left: 32px;
    color: #9e9e9e;
    background-color: #fff;
    cursor: auto;
    /*color: black;*/
  }
  #demo-2 input:-moz-placeholder {
    color: transparent;
  }
  #demo-2 input::-webkit-input-placeholder {
    color: transparent;
  }
</style>



// WEBPACK FOOTER //
// src/components/chat/ChatList.vue